export const queries = {
  QUERY_START: "?",
  QUERY_SEPARATOR: "&",
  QUERY_NAME_VALUE_SEPARATOR: "=",
  ADVANCE_SEARCH_WORD_SEPARATOR: ",",

  FILTERING_COMPARATOR_SEPARATOR_QUERY: ":",

  PAGE_QUERY: "page",
  SIZE_QUERY: "size",
  OFFSET_QUERY: "offset",
  ORDER_BY_QUERY: "orderBy",
  DIRECTION_QUERY: "direction",
  SORT: "sort",

  EMAIL_QUERY: "email"
};
